export default __webpack_public_path__ + "static/icon-29-5-68d8c7c54957b38adac4bc133406577b.png";